import React, {useEffect, useState} from "react";
import _, {isEmpty} from "lodash";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";

const AddEditProductImage = ({
                                 selectedProductImageId = '',
                                 productImageList = [],
                                 productsList = [],
                                 isMultiple = false,
                                 afterProductImageSelected = undefined,
                                 selectedProductImageList = undefined,
                                 setSelectedProductImageList = undefined,
                                 statistics = undefined,
                                 cssClass = 'px-2 py-1 text-sm'
                             }) => {
    const [showModal, setShowModal] = useState(false);
    const [currentProductImage, setCurrentProductImage] = useState(null);

    useEffect(() => {
        if (showModal) {
            if (selectedProductImageId) {
                const productImageMap = _.keyBy(productImageList, 'id');
                setCurrentProductImage(productImageMap[selectedProductImageId]);
            } else {
                prepareInitialProductImageList();
            }
        }
    }, [showModal]);

    const prepareInitialProductImageList = () => {
        let allProductImages = [];
        _.forEach(productsList, (product) => {
            _.forEach(product?.images, (productImage) => {
                productImage.productTitle = product.title;
                productImage.onlineStoreUrl = product.onlineStoreUrl;
                allProductImages.push(productImage);
            });
        });

        allProductImages = _.shuffle(allProductImages);
        allProductImages = _.chunk(allProductImages, (statistics?.requiredImagesCount * 2))[0];
        setSelectedProductImageList(allProductImages);
    }

    const handleConfirmAction = async () => {
        const existingProductImage = {...currentProductImage};
        afterProductImageSelected(existingProductImage);
        setShowModal(false);
    }

    const handleSingleSelectedProductImage = (productImage, product) => {
        productImage.productTitle = product.title;
        productImage.onlineStoreUrl = product.onlineStoreUrl;
        setCurrentProductImage(productImage);
    }

    const handleMultiSelectedProductImage = (productImage, product) => {
        const existingProductImageList = [...selectedProductImageList];
        productImage.productTitle = product.title;
        productImage.onlineStoreUrl = product.onlineStoreUrl;

        const existingProductImage = existingProductImageList?.find((selectedProductImage) => selectedProductImage?.id === productImage?.id);
        if (!existingProductImage) {
            existingProductImageList.push(productImage);
            setSelectedProductImageList(existingProductImageList);
        } else {
            const filteredProductImageList = existingProductImageList?.filter((selectedProductImage) => selectedProductImage?.id !== productImage?.id);
            setSelectedProductImageList(filteredProductImageList);
        }
    }

    return (
        <>
            <button
                className={`button-sky-outline ${cssClass}`}
                onClick={() => setShowModal(true)}>
                Add Image
            </button>

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative my-6 mx-auto w-4/5">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-center justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        Add Product Images
                                    </h3>
                                    <div className={'flex items-center justify-center'}>
                                        {selectedProductImageList?.length} / {statistics?.requiredImagesCount}
                                    </div>
                                    <div className="flex items-center justify-end">
                                        <button
                                            className="ml-2 text-gray-500 font-bold border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowModal(false)}>
                                            Cancel
                                        </button>
                                        <button
                                            className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 rounded px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={handleConfirmAction}>
                                            Confirm Product Images
                                        </button>
                                    </div>
                                </div>
                                {/*body*/}
                                <div
                                    className="relative p-5 flex-auto bg-gray-500 overflow-y-scroll add-product-image-container">
                                    {productImageList?.length > 0 &&
                                        <div
                                            className="flex flex-wrap text-center justify-center">
                                            {productImageList?.map((productImage, productImageIndex) => (
                                                <ProductImageSmall
                                                    afterImageSelected={(event) => {
                                                        setCurrentProductImage(productImage);
                                                    }}
                                                    dimension={300}
                                                    isSelected={currentProductImage?.id === productImage?.id}
                                                    key={`selected-product-image-${productImageIndex}`}
                                                    imageUrl={productImage?.url}/>
                                            ))}
                                        </div>
                                    }

                                    {productsList?.length > 0 &&
                                        <>
                                            {productsList?.map((product, productIndex) => (
                                                <div key={productIndex}>
                                                    <div
                                                        className={'text-lg font-semibold text-white mb-2'}>{product?.title}</div>
                                                    <div className="flex flex-wrap justify-start mb-6">
                                                        {product?.images?.map((productImage, productImageIndex) => (
                                                            <ProductImageSmall
                                                                afterImageSelected={(event) => {
                                                                    if (isMultiple) {
                                                                        handleMultiSelectedProductImage(productImage, product);
                                                                    } else {
                                                                        handleSingleSelectedProductImage(productImage, product);
                                                                    }
                                                                }}
                                                                dimension={100}
                                                                isSelected={!isMultiple ? currentProductImage?.id === productImage?.id :
                                                                    selectedProductImageList?.find((selectedProductImage) => selectedProductImage?.id === productImage?.id)}
                                                                key={`selected-product-image-${productImageIndex}`}
                                                                imageUrl={productImage?.url}/>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    }

                                </div>
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default AddEditProductImage
